/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */
function find (list, f) {
  return list.filter(f)[0]
}

/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */
export function deepCopy (obj, cache = []) {
  // just return if obj is immutable value
  if (obj === null || typeof obj !== 'object') {
    return obj
  }

  // if obj is hit, it is in circular structure
  const hit = find(cache, c => c.original === obj)
  if (hit) {
    return hit.copy
  }

  const copy = Array.isArray(obj) ? [] : {}
  // put the copy into cache at first
  // because we want to refer it in recursive deepCopy
  cache.push({
    original: obj,
    copy
  })

  Object.keys(obj).forEach(key => {
    copy[key] = deepCopy(obj[key], cache)
  })

  return copy
}

/**
 * forEach for object
 */
export function forEachValue (obj, fn) {
  Object.keys(obj).forEach(key => fn(obj[key], key))
}

/**
 * Object をマージする
 * @param  {Object} baseObj
 * @param  {Object} margeObj
 * @return {Object}
 */
export function margeObject (baseObj, margeObj) {
  forEachValue(margeObj, (obj, key) => {
    if (baseObj.hasOwnProperty(key)) {
      let val = obj
      // if (/^([1-9]\d*|0)(\.\d+)?$/.test(val)) {
      //   val = val * 1
      // }
      baseObj[key] = val
    }
  })
  return baseObj
}

/**
 * ObjectをParamの文字列にして返す
 * @param {Object} obj
 */
export function ObjToParam (obj) {
  let params = []
  forEachValue(obj, (val, key) => {
    params.push(key + '=' + encodeURIComponent(obj[key]))
  })
  return params.join('&')
}

/**
 * 数値にカンマを挿入する
 * @return {Array}
 */
export function numSeparate (num) {
  return String(num).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
}



// WEBPACK FOOTER //
// ./src/lib/util/index.js